import { solarTermOf, termPhrase } from "../components/qy/season";

/** 上海时区的「今天」，年月日落到本地 Date 上供节气函数使用。 */
export function shanghaiToday(now = new Date()): Date {
  const [year, month, day] = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Shanghai", year: "numeric", month: "2-digit", day: "2-digit" }).format(now).split("-").map(Number);
  return new Date(year, month - 1, day);
}
/** 刊头日期行：「2026年10月19日 星期一 · 时值寒露」，只说真实的日子。 */
export function dateLine(date: Date): string {
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 星期${WEEKDAY[date.getDay()]} · ${termPhrase(date)}`;
}
export const isoDay = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

/** 当天所在节气的名字（「寒露」）。 */
export const termName = (date: Date) => solarTermOf(date).name;

const STEMS = ["甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸"];
const BRANCHES = ["子", "丑", "寅", "卯", "辰", "巳", "午", "未", "申", "酉", "戌", "亥"];
// 春节（正月初一）公历日，表外年份不出干支年；与共享件 season.ts 的表同源，只用来判断是否已过年。
const LUNAR_NEW_YEAR: Record<number, string> = { 2025: "01-29", 2026: "02-17", 2027: "02-06", 2028: "01-26", 2029: "02-13", 2030: "02-03", 2031: "01-23", 2032: "02-11", 2033: "01-31", 2034: "02-19", 2035: "02-08" };
/** 干支纪年（「丙午年」），春节前仍算上一年；表外年份返回空串。 */
export function ganzhiYear(date: Date): string {
  const [month, day] = (LUNAR_NEW_YEAR[date.getFullYear()] ?? "").split("-").map(Number);
  if (!month) return "";
  const year = date.getMonth() + 1 < month || (date.getMonth() + 1 === month && date.getDate() < day) ? date.getFullYear() - 1 : date.getFullYear();
  return `${STEMS[(year - 4) % 10]}${BRANCHES[(year - 4) % 12]}年`;
}
export const WEEKDAY = ["日", "一", "二", "三", "四", "五", "六"];
